import { FileType } from '@lmt/shared-types';

export type Result =
  | {
      type: 'error';
      error: string;
    }
  | {
      type: 'success';
    }
  | {
      type: 'cancel';
    };

let _checkMiniScreenPdfFile: (fileName: string) => Promise<Result>;

export function setCheckMiniScreenPdfFile(
  checkMiniScreenPdfFileFunction: (fileName: string) => Promise<Result>,
): void {
  _checkMiniScreenPdfFile = checkMiniScreenPdfFileFunction;
}

export async function checkMiniScreenPdfFile(
  fileName: string,
): Promise<Result> {
  return await _checkMiniScreenPdfFile?.(fileName);
}

export interface MeasurementFileInfo {
  measurementId: number;
  path: string;
  type: FileType;
  comment: string;
  patientId: number;
}

let _uploadMeasurementFile: (filePath: string) => Promise<Buffer>;

export function setUploadMeasurementFile(
  uploadMeasurementFileFunction: (filePath: string) => Promise<Buffer>,
): void {
  _uploadMeasurementFile = uploadMeasurementFileFunction;
}

export async function uploadMeasurementFile(filePath: string): Promise<Buffer> {
  return await _uploadMeasurementFile?.(filePath);
}

let _deleteMiniScreenPdfFile: (fileName: string) => Promise<void>;

export function setDeleteMiniScreenPdfFile(
  deleteMiniScreenPdfFileFunction: (fileName: string) => Promise<void>,
): void {
  _deleteMiniScreenPdfFile = deleteMiniScreenPdfFileFunction;
}

export async function deleteMiniScreenPdfFile(fileName: string): Promise<void> {
  return await _deleteMiniScreenPdfFile?.(fileName);
}
